import React from "react";
import CIcon from "@coreui/icons-react";
import AKPaginationButton from "./AKPaginationButton";
import { divisionTypes } from "../../../constants/division-types";
import { allDivisions } from "../../../constants/constants";

const AKPaginationButtons = ({
  page,
  setPage,
  numberOfPages,
  divisionNameForTheme,
}) => {
  const renderPaginationButtons = () => {
    let paginationButtons = [];

    if (numberOfPages <= 10) {
      for (let i = 0; i < numberOfPages; i++) {
        paginationButtons.push(
          <AKPaginationButton
            divisionNameForTheme={divisionNameForTheme}
            key={i}
            isSelected={page === i + 1}
            setPage={setPage}
            pageNumber={i + 1}
          />
        );
      }
    } else {
      if (page - 5 <= 0) {
        for (let i = 0; i < 10; i++) {
          if (i >= 0) {
            paginationButtons.push(
              <AKPaginationButton
                divisionNameForTheme={divisionNameForTheme}
                key={i}
                isSelected={page === i + 1}
                setPage={setPage}
                pageNumber={i + 1}
              />
            );
          }
        }
      } else if (page + 5 > numberOfPages) {
        for (let i = numberOfPages - 10; i < numberOfPages; i++) {
          if (i >= 0) {
            paginationButtons.push(
              <AKPaginationButton
                divisionNameForTheme={divisionNameForTheme}
                key={i}
                isSelected={page === i + 1}
                setPage={setPage}
                pageNumber={i + 1}
              />
            );
          }
        }
      } else {
        for (let i = page - 5; i < page + 5; i++) {
          if (i >= 0) {
            paginationButtons.push(
              <AKPaginationButton
                divisionNameForTheme={divisionNameForTheme}
                key={i}
                isSelected={page === i + 1}
                setPage={setPage}
                pageNumber={i + 1}
              />
            );
          }
        }
      }
    }

    return paginationButtons;
  };

  const handleBackButtonClick = () => {
    setPage(page - 1);
  };

  const handleNextButtonClick = () => {
    setPage(page + 1);
  };

  return (
    <div
      className={`${
        divisionNameForTheme && allDivisions.includes(divisionNameForTheme)
          ? `pagination-container-${divisionNameForTheme.toLowerCase()}`
          : "pagination-container"
      }`}
    >
      <button
        className="back-button"
        onClick={handleBackButtonClick}
        disabled={page === 1}
      >
        <CIcon name="cil-arrow-left" />
      </button>
      {page && renderPaginationButtons()}
      <button
        className="next-button"
        onClick={handleNextButtonClick}
        disabled={page === numberOfPages}
      >
        <CIcon name="cil-arrow-right" />
      </button>
    </div>
  );
};

export default AKPaginationButtons;
